module.exports = __webpack_public_path__ + "static/media/NTCR.cf70c246.csv";